var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiencereach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#224876"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 25.2656C22.2999 25.2656 24.1654 23.027 24.1654 20.2656C24.1654 17.5042 22.2999 15.2656 19.9987 15.2656C17.6975 15.2656 15.832 17.5042 15.832 20.2656C15.832 23.027 17.6975 25.2656 19.9987 25.2656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1665 29.5156C27.4165 28.0156 25.9999 26.7656 24.1665 26.0156C23.6665 25.8489 23.0832 25.8489 22.6665 26.0989C21.8332 26.5989 20.9999 26.8489 19.9999 26.8489C18.9999 26.8489 18.1665 26.5989 17.3332 26.0989C16.9165 25.9322 16.3332 25.8489 15.8332 26.0989C13.9999 26.8489 12.5832 28.0989 11.8332 29.5989C11.2499 30.6822 12.1665 31.9322 13.4165 31.9322H26.5832C27.8332 31.9322 28.7499 30.6822 28.1665 29.5156Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_3871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6726 26.6402C36.1931 22.834 36.1918 16.9141 32.6726 13.1093C32.5402 12.9663 32.3162 12.9635 32.1789 13.1018L31.4491 13.8374C31.318 13.9693 31.3152 14.1816 31.4409 14.3187C34.3129 17.4536 34.3135 22.2956 31.4409 25.4311C31.3152 25.5682 31.3182 25.7805 31.4491 25.9124L32.1789 26.648C32.3162 26.7861 32.5402 26.7833 32.6726 26.6402ZM30.2335 24.2289C32.4234 21.7527 32.421 17.9941 30.2335 15.5207C30.1025 15.3724 29.875 15.3677 29.7362 15.5084L29.0059 16.2483C28.8788 16.3772 28.8702 16.5848 28.9888 16.722C30.5478 18.5256 30.5444 21.228 28.9888 23.0273C28.8702 23.1646 28.8785 23.3721 29.0059 23.501L29.7362 24.2409C29.875 24.3819 30.1027 24.3769 30.2335 24.2289Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_3871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7496,
    height: 10.9997,
    fill: "white",
    transform: "matrix(0 1 -1 0 36 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiencereach);
export default __webpack_public_path__ + "static/media/audiencereach.cccef468c0b5525dc1d55f92cc0ac8a0.svg";
export { ForwardRef as ReactComponent };